export default "__VITE_ASSET__Bg4PSHD7__"